let baseUrl = 'https://rotate-interview-api.jonathanjanssens.com'

if (process.env.NODE_ENV === 'development') {
    baseUrl = 'https://rotate-interview-api.test'
}

export const API_BASEURL = baseUrl
